// extracted by mini-css-extract-plugin
export var actions = "_pv-4";
export var item = "_pv-1";
export var price = "_pv-3";
export var quantity = "_pv-2";
export var table = "_pv-0";